import { useEffect, useState } from "react";
import { Timer } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export const timeLeft = (closesAt) => {
  if (!closesAt) return null;
  const ms = new Date(closesAt).getTime() - Date.now();
  if (Number.isNaN(ms)) return null;
  if (ms <= 0) return { closed: true, label: "Window closed" };
  const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000), s = Math.floor((ms % 60000) / 1000);
  return { closed: false, urgent: ms < 86400000, label: d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}:${pad(m)}:${pad(s)}` };
};

export const DealCountdown = ({ closesAt, size = "sm", testid, onDark = false }) => {
  const [t, setT] = useState(() => timeLeft(closesAt));
  useEffect(() => {
    setT(timeLeft(closesAt));
    if (!closesAt) return undefined;
    const id = setInterval(() => setT(timeLeft(closesAt)), 1000);
    return () => clearInterval(id);
  }, [closesAt]);
  if (!t) return null;
  const tone = onDark
    ? (t.closed ? "border-white/30 text-white/60" : t.urgent ? "border-rose-300/60 bg-rose-400/20 text-rose-100 animate-pulse" : "border-white/40 bg-white/15 text-white")
    : t.closed ? "border-slate-300 text-slate-500" : t.urgent ? "border-rose-600/50 bg-rose-600/[0.08] text-rose-700 animate-pulse" : "border-[#6D28D9]/50 bg-[#6D28D9]/[0.08] text-[#6D28D9]";
  const big = size === "lg";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 border font-mono2 uppercase tracking-[0.15em] ${big ? "px-3 py-1.5 text-[11px]" : "px-2 py-0.5 text-[9px]"} ${tone}`}>
      <Timer className={big ? "h-3.5 w-3.5" : "h-3 w-3"} />
      {t.closed ? t.label : `${t.urgent ? "Closing soon" : "Closes in"} · ${t.label}`}
    </span>
  );
};
